import {
    Box,
    Heading,
    Text,
    Flex,
    Icon,
    Link,
    Image,
    Button,
    HStack,
    VStack,
    useColorModeValue,
  } from "@chakra-ui/react";
  import { EmailIcon, DownloadIcon } from "@chakra-ui/icons";
  import { FaGithub, FaLinkedin } from "react-icons/fa"; // Import Font Awesome icons
  // import { MdOutlineMailOutline, FaLinkedin } from "react-icons/md"; // Import Font Awesome icons
  

  export default function Home() {
    const handleDownloadResume = () => {
      // Replace with the actual path to your resume PDF file
      const resumeUrl = "\Deepak_Resume.pdf";
      const link = document.createElement("a");
      link.href = resumeUrl;
      link.download = "Deepak_Resume.pdf";
      link.click();
    };
  
    return (
      <Box minH="90vh" py={{base:"80px",md:"170px"}} px={4} bg={useColorModeValue('white', '#78B7D0')} id="home">
        <Flex
          direction={{ base: "column-reverse", md: "row" }}
          justifyContent="space-evenly"
          alignItems="center"
          flexWrap="wrap"
        >
          <Box
            order={{ base: 2, md: 1 }}
            flex={{ base: "0 0 100%", md: "0 0 auto" }}
            ml={{ base: 0, md: 8 }}
            mb={{ base: 8, md: 0 }}
            maxW={{ base: "100%", md: "50%" }}
            textAlign={{ base: "center", md: "left" }}
          >
            <VStack alignItems={{base:"center",md:"start"}} spacing={4}>
              <Heading as="h1"  fontSize={{ base: "2xl", md: "4xl" }}>
                Hello, it's me
              </Heading>
              <Heading fontSize={{ base: "4xl", md: "6xl" }} color={'#3182CE'} >Deepak</Heading>
              <Heading fontSize={{ base: "1.5xl", md: "2xl" }} >And I'm a</Heading>
              <Box alignItems={{base:"center",md:"start"}} box-shadow={' rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;'}>

              <a href="https://git.io/typing-svg"><img src="https://readme-typing-svg.demolab.com?font=Fira+Code&weight=700&size=30&pause=1000&color=3182CE&random=false&width=435&lines=Full+Stack+Web+Developer;MERN+Stack+Developer;Frontend+Developer;React+Devleoper" alt="Typing SVG" /></a>
              </Box>
             
              <HStack spacing={4}>
                <Link href="mailto:dkp041297@gmail.com">
                  <EmailIcon
                    boxSize={{ base: 6, md: 8 }}
                    color="#3182CE"
                    _hover={{ color: "blue.700" }}
                  />
                  {/* <MdOutlineMailOutline/> */}
                </Link>
                <Link href="https://github.com/deepak1181" target="_blank">
                  <Icon
                    as={FaGithub}
                    boxSize={{ base: 6, md: 8 }}
                    color="#3182CE"
                    _hover={{ color: "blue.700" }}
                  />
                </Link>
                <Link
                  href="https://www.linkedin.com/in/deepak-prajapati-offical/"
                  target="_blank"
                >
                  <Icon
                    as={FaLinkedin}
                    boxSize={{ base: 6, md: 8 }}
                    color="#3182CE"
                    _hover={{ color: "blue.700" }}
                  />
                </Link>
              </HStack>
              <Box id="resume-button-2" mt={4}>
                <Button
                  onClick={handleDownloadResume}
                  colorScheme="blue"
                  backgroundColor="#3182CE"
                >
                <a target="_blank" href="https://drive.google.com/file/d/1drFAN3aeuGJGFxBBqzsaSuZaeI6e_JH5/view?usp=sharing"> Resume <DownloadIcon boxSize={5} ml={2} /></a> 
                </Button>
              </Box>
            </VStack>
          </Box>
          <Box
            order={{ base: 1, md: 2 }}
            flex={{ base: "0 0 100%", md: "0 0 auto" }}
            mr={{ base: 0, md: 8 }}
            maxW={{ base: "100%", md: "50%" }}
          >
            <Image
              // src="https://avatars.githubusercontent.com/u/112808279?v=4"
              src="https://avatars.githubusercontent.com/u/95513828?v=4"
              alt="Profile"
              boxSize={{ base: "400px", md: "400px" }}
              borderRadius="50%"
              border="2px solid #3182CE"
              boxShadow="xl"
        
              
            />
          </Box>
        </Flex>
      </Box>
    );
  }
  